export const MESSAGING_DROPDOWN_PORTAL_SELECTOR = '.messaging-dropdown--portal';

export { SHELL_HEADER_DROPDOWN_Z_INDEX } from '../../notifications/notificationUtils';

export function isMessagingDropdownPortalTarget(target) {
  return Boolean(target?.closest?.(MESSAGING_DROPDOWN_PORTAL_SELECTOR));
}
